/* unplugin-vue-components disabled */import { render } from "./xcjcd.vue?vue&type=template&id=90736472"
import script from "./xcjcd.vue?vue&type=script&lang=js"
export * from "./xcjcd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__